import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import {composeWithDevTools} from 'redux-devtools-extension';
import rootReducer from './reducers';

let store;

/**
 * Binds the Redux store used by `getStore()` for code outside React (e.g. UserUtils).
 * One-app builds the store in `apps/one-app/src/store` (persist + middleware); it must
 * call this so CCM helpers that import `getStore` from this module see the same instance.
 */
export function setStore(nextStore) {
    store = nextStore;
}

export default function create(initialState) {
    store = createStore(
        rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(thunkMiddleware, promiseMiddleware))
    );

    return store;
}

export const getStore = () => {
    return store;
};
